import { createFileRoute } from '@tanstack/react-router'
import { TrainersStudentsPage } from '@/features/trainers'

export const Route = createFileRoute('/_authenticated/trainers/students')({
  component: TrainersStudentsPage,
})
